(function ($) {
	'use strict';

	var block = $('.leadership-cards');

	if (!block.length) {
		return;
	}
	else {
		leadershipCards(block);
	}


	function leadershipCards(el) {
		el.each(function () {
			var container = $(this);
			var cards = container.find('.leadership-card');

			cards.each(function () {
				var card = $(this);
				var bioInner = card.find('.leadership-card__bio-inner');

				var toggleButton = card.find('.leadership-card__bio-toggle');

				toggleButton.on('click', function() {
					var isExpanded = bioInner.hasClass('open');

					if (isExpanded) {
						bioInner.removeClass('open');
						toggleButton.attr('aria-expanded', 'false')
							.text('Read More');
					} else {
						bioInner.addClass('open');
						toggleButton.attr('aria-expanded', 'true')
							.text('Read Less');
					}
				});
			});
		});
	}

})(jQuery);
